import React from 'react'
import { Meta } from '../../../components'
import { metaRenderer } from '../../../utils'
import { useSystem } from '../../../features/system/hook'
import { useInternationalization } from '../../../features/i18n/hook'

const Metas = ({data, isDesktop, isOpen}) => {
  const { translate, language } = useInternationalization()

  const {
    types,
    // since,
    approaches,
    location,
    issues
  } = data

  const {
    approachOptions,
    issueOptions,
    organizationTypeOptions
  } = useSystem()

  const approachesRendered = metaRenderer(approaches, approachOptions, language)
  const typesRendered = metaRenderer(types, organizationTypeOptions, language)
  const issuesRendered = metaRenderer(issues, issueOptions, language)

  return isDesktop ? (
    <div className="flex flex-wrap justify-between w-full">
      <div className="w-1/2 lg:w-1/4">
        <Meta
          className="mb-3 lg:mb-2 pr-2 lg:pr-4"
          label={translate('SEARCH', 'type')}
          value={typesRendered}
        />
        {/* <Meta
          className="mb-3 lg:mb-2 pr-2 lg:pr-4"
          label="Established Since"
          value={since}
        /> */}
      </div>
      <div className="w-1/2 lg:w-1/4 order-3 lg:order-2">
        <Meta
          className="mb-3 lg:mb-2 pr-2 lg:pr-4"
          label={translate('SEARCH', 'location')}
          value={location}
        />
      </div>
      <div className="w-1/2 lg:w-1/4 order-2 lg:order-3">
        <Meta
          className="mb-3 lg:mb-2 pr-2 lg:pr-4"
          label={translate('APPROACH', 'singular')}
          value={approachesRendered}
        />
      </div>
      <div className="w-1/2 lg:w-1/4 order-4">
        <Meta
          className="mb-3 lg:mb-2 pr-2 lg:pr-4"
          label={translate('ISSUE', 'plural')}
          value={issuesRendered}
        />
      </div>
    </div>
  ) : (
    <div className="flex flex-wrap justify-between w-full">
      <div className="w-1/2">
        <Meta
          className="mb-3 pr-2"
          label={translate('SEARCH', 'type')}
          value={typesRendered}
        />
        {/* <Meta
          className="mb-3 pr-2"
          label="Established Since"
          value={since}
        /> */}
      </div>
      <div className="w-1/2">
        <Meta
          className="mb-3 pr-2"
          label={translate('APPROACH', 'singular')}
          value={approachesRendered}
        />
      </div>
      {
        isOpen &&
        <React.Fragment>
          <div className="w-1/2">
            <Meta
              className="mb-3 pr-2"
              label={translate('SEARCH', 'location')}
              value={location}
            />
          </div>
          <div className="w-1/2">
            <Meta
              className="mb-3 pr-2"
              label={translate('ISSUE', 'plural')}
              value={issuesRendered}
            />
          </div>
        </React.Fragment>
      }
    </div>
  )
}

export { Metas }
